// Schema declarativo das 14 etapas do wizard de Posicionamento
export const POSITIONING_STEPS = [
  {
    key: "marca_momento",
    title: "Marca & Momento de Marca",
    desc: "Onde você está hoje. Isso define o tom das próximas 13 etapas.",
    fields: [
      { key: "estagio", label: "Estágio da marca", type: "select", options: ["Início (0-6m)", "Crescimento (6-24m)", "Estabelecida (2+ anos)"] },
      { key: "momento", label: "Momento atual", type: "textarea", placeholder: "Ex: acabamos de lançar, sem tração; ou: crescendo mas sem foco…" },
      { key: "url_principal", label: "URL / bio principal", type: "text" },
    ],
    aiPrompt: (data, brand) => `Sou a marca "${brand?.name}" no nicho "${brand?.industry || ""}". Estágio: ${data.estagio || "não informado"}. Momento: ${data.momento || "não informado"}. Sugira em 3 bullets o que devo priorizar nas próximas 4 semanas.`,
  },
  {
    key: "diagnostico",
    title: "Diagnóstico",
    desc: "O que está travando. Seja brutalmente honesto.",
    fields: [
      { key: "desafio", label: "Qual o desafio central?", type: "textarea", placeholder: "Ex: gero conteúdo mas não vira lead qualificado." },
      { key: "urgencia", label: "Urgência (1-10)", type: "number", min: 1, max: 10 },
      { key: "declaracao", label: "Declaração de posicionamento atual (se houver)", type: "textarea" },
    ],
    aiPrompt: (data) => `Meu desafio é: "${data.desafio}". Urgência ${data.urgencia}/10. Diagnostique 3 possíveis causas raiz e a primeira alavanca a puxar.`,
  },
  {
    key: "sociedade_publico",
    title: "Sociedade & Público",
    desc: "Tendências culturais que afetam você + quem você atende.",
    fields: [
      { key: "tendencias", label: "Tendências relevantes (linhas)", type: "list" },
      { key: "publico_alvo", label: "Público-alvo (persona principal)", type: "textarea" },
      { key: "publicos_interesse", label: "Sub-públicos de interesse", type: "list" },
    ],
    aiPrompt: (data) => `Meu público é: "${data.publico_alvo}". Liste 5 tendências culturais/comportamentais brasileiras 2026 que afetam esse público, com como cada uma pode ser aproveitada.`,
  },
  {
    key: "ponto_a_b",
    title: "Ponto A → B",
    desc: "Como está a vida do público hoje (A) e como fica depois da sua marca (B).",
    fields: [
      { key: "ponto_a", label: "Ponto A (estado atual do público)", type: "textarea" },
      { key: "ponto_b", label: "Ponto B (estado desejado)", type: "textarea" },
      { key: "ponte", label: "Sua marca como ponte entre A e B", type: "textarea" },
    ],
    aiPrompt: (data) => `Público sai de "${data.ponto_a}" para "${data.ponto_b}" através da minha marca. Reescreva a ponte em 1 parágrafo persuasivo (60-80 palavras).`,
  },
  {
    key: "missao_comunidade",
    title: "Missão & Comunidade",
    desc: "Por que você existe além do produto.",
    fields: [
      { key: "missao", label: "Missão (1 frase)", type: "textarea" },
      { key: "valores", label: "Valores inegociáveis (3-5)", type: "list" },
      { key: "comunidade", label: "Como sua comunidade se identifica", type: "textarea" },
    ],
    aiPrompt: (data) => `Missão: "${data.missao}". Valores: ${(data.valores || []).join(", ")}. Escreva um manifesto de 4 linhas que a comunidade adoraria compartilhar.`,
  },
  {
    key: "personalidade",
    title: "Personalidade",
    desc: "A voz e temperamento da marca.",
    fields: [
      { key: "arquetipo", label: "Arquétipo dominante", type: "select", options: ["Herói", "Sábio", "Rebelde", "Criador", "Amante", "Explorador", "Governante", "Bobo da Corte", "Cuidador", "Cara Comum", "Inocente", "Mago"] },
      { key: "atributos_desejados", label: "5 adjetivos que descrevem a marca", type: "list" },
      { key: "atributos_indesejados", label: "3 adjetivos que você recusa", type: "list" },
      { key: "tom_voz", label: "Tom de voz em 1 linha", type: "text" },
      { key: "tensao_cultural", label: "Tensão cultural que você navega", type: "textarea" },
    ],
    aiPrompt: (data) => `Arquétipo ${data.arquetipo}. Adjetivos: ${(data.atributos_desejados || []).join(", ")}. Recusa: ${(data.atributos_indesejados || []).join(", ")}. Gere 3 exemplos de posts (1 linha cada) nesse tom.`,
  },
  {
    key: "mercado",
    title: "Mercado",
    desc: "Quem são seus concorrentes diretos e indiretos.",
    fields: [
      { key: "players_diretos", label: "Concorrentes diretos", type: "list" },
      { key: "substitutos", label: "Substitutos indiretos", type: "list" },
      { key: "vantagem_injusta", label: "Sua vantagem injusta", type: "textarea" },
    ],
    aiPrompt: (data) => `Concorrentes: ${(data.players_diretos || []).join(", ")}. Substitutos: ${(data.substitutos || []).join(", ")}. Vantagem injusta: "${data.vantagem_injusta}". Sugira 3 formas de comunicar essa vantagem sem parecer arrogante.`,
  },
  {
    key: "mapa_perceptual",
    title: "Mapa Perceptual",
    desc: "2 eixos + posicione sua marca e concorrentes arrastando.",
    fields: [
      { key: "map", label: "Mapa perceptual interativo", type: "perceptual_map" },
      { key: "criterios_lacuna", label: "3 critérios de lacuna no mercado", type: "list" },
    ],
    aiPrompt: (data) => {
      const map = data.map || {};
      const pts = (map.points || []).map((p) => `${p.name}(${Math.round(p.x)},${Math.round(p.y)})`).join(", ");
      return `Eixos: ${map.eixo_x_label || "?"} vs ${map.eixo_y_label || "?"}. Posições: ${pts}. Lacunas: ${(data.criterios_lacuna || []).join(", ")}. Aponte qual quadrante do mapa está vazio e por quê ocupar.`;
    },
  },
  {
    key: "pilares_tensao",
    title: "Pilares & Tensão Cultural",
    desc: "3-5 pilares de conteúdo + a tensão que você resolve.",
    fields: [
      { key: "pilares", label: "Pilares de conteúdo (3-5)", type: "list" },
      { key: "tensao", label: "Tensão cultural central", type: "textarea" },
      { key: "big_idea", label: "Big Idea da marca (1 frase)", type: "textarea" },
    ],
    aiPrompt: (data) => `Pilares: ${(data.pilares || []).join(", ")}. Tensão: "${data.tensao}". Escreva 3 versões da Big Idea, cada uma com uma emoção dominante (raiva, esperança, ambição).`,
  },
  {
    key: "auditoria_percepcao",
    title: "Auditoria de Percepção",
    desc: "Como o mercado te vê hoje vs. como você quer ser visto.",
    fields: [
      { key: "percepcao_atual", label: "Como o público te descreve hoje", type: "textarea" },
      { key: "percepcao_desejada", label: "Como você quer ser descrito", type: "textarea" },
      { key: "gaps", label: "3 gaps entre atual e desejado", type: "list" },
    ],
    aiPrompt: (data) => `Percepção atual: "${data.percepcao_atual}". Desejada: "${data.percepcao_desejada}". Gaps: ${(data.gaps || []).join(", ")}. Proponha 3 ações concretas de conteúdo para fechar o maior gap.`,
  },
  {
    key: "frase_posicionamento",
    title: "Frase de Posicionamento",
    desc: "A frase-síntese. Gere 3 opções e escolha 1.",
    fields: [
      { key: "opcao_1", label: "Opção 1", type: "textarea" },
      { key: "opcao_2", label: "Opção 2", type: "textarea" },
      { key: "opcao_3", label: "Opção 3", type: "textarea" },
      { key: "frase_final", label: "Frase escolhida (a única)", type: "textarea" },
    ],
    aiPrompt: (data, brand, allSteps) => {
      const p = allSteps || {};
      return `Baseado em: público=${p.sociedade_publico?.data?.publico_alvo || "?"}, ponto_a→b=${p.ponto_a_b?.data?.ponte || "?"}, big idea=${p.pilares_tensao?.data?.big_idea || "?"}. Gere 3 frases de posicionamento no formato "Para [público], [marca] é o(a) [categoria] que [diferencial], porque [prova]."`;
    },
  },
  {
    key: "distribuicao",
    title: "Distribuição",
    desc: "Editorias, canais e frequência de postagem.",
    fields: [
      { key: "editorias", label: "Editorias/temas recorrentes", type: "list" },
      { key: "canais", label: "Canais principais (Instagram, LinkedIn…)", type: "list" },
      { key: "frequencia", label: "Frequência semanal por canal", type: "textarea" },
      { key: "abordagem", label: "Abordagem editorial em 1 linha", type: "text" },
    ],
    aiPrompt: (data) => `Editorias: ${(data.editorias || []).join(", ")}. Canais: ${(data.canais || []).join(", ")}. Sugira um mix ideal 60/30/10 (Alcance/Autoridade/Relação) traduzido em número de posts semanais.`,
  },
  {
    key: "plano_90_dias",
    title: "Plano de 90 dias",
    desc: "5 elementos: OKR, primeiros conteúdos, campanhas, parcerias, métricas.",
    fields: [
      { key: "okr", label: "Objetivo + 3 Resultados-chave", type: "textarea" },
      { key: "primeiros_conteudos", label: "5 primeiros posts (títulos)", type: "list" },
      { key: "campanhas", label: "Campanhas planejadas (2-3)", type: "list" },
      { key: "parcerias", label: "Parcerias possíveis", type: "list" },
      { key: "metricas", label: "Métricas de acompanhamento", type: "list" },
    ],
    aiPrompt: (data, brand) => `Marca "${brand?.name}". OKR: "${data.okr}". Sugira um cronograma semana-a-semana de 12 semanas com 1 marco principal por semana.`,
  },
  {
    key: "documento_final",
    title: "Documento Estratégico",
    desc: "Revise tudo. Exporte o PDF final.",
    fields: [
      { key: "notas_finais", label: "Notas / observações finais", type: "textarea" },
    ],
    aiPrompt: null,
  },
];
